const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;
  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} id="modal-closebtn">&times;</button>
        <h4>{title}</h4>
        {children}
      </div>
    </div>
  );
};
export default Modal;
